import React from 'react';

/**
 * The check icon
 */
const CheckIcon = () => (
  <span className="check-icon">
    <svg viewBox="0 0 12 10">
      <polyline points="1.5 6 4.5 9 10.5 1" />
    </svg>
  </span>
);

export default CheckIcon;
